module.exports = __webpack_public_path__ + "static/media/right-bg-login.e72c2935.png";